import React, { createContext, PureComponent } from 'react';
import License from 'types/License';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  isCardEnabled: false,
  license: undefined,
  setCardEnabled: () => undefined,
  setLicense: (_: License) => _,
  pmpt: undefined,
};

export const LicenseNoteContext = createContext<Partial<ILicenseNoteContext>>(initialValue);

export class LicenseNoteContextProvider extends PureComponent<IProps, Partial<ILicenseNoteContext>> {
  constructor(props) {
    super(props);
    this.state = {
      isCardEnabled: false,
      license: '',
      pmpt: 0,
    };
  }

  setCardEnabled = (isCardEnabled: boolean, pmpt: number) => this.setState({ isCardEnabled, pmpt });

  setLicense = (license: string) => this.setState({ license });

  render() {
    const { Provider } = LicenseNoteContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setCardEnabled: this.setCardEnabled,
          setLicense: this.setLicense,
        }}
      >
        {children}
      </Provider>
    );
  }
}
